import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";

export default function ResetPassword() {

    const [formData, setFormData] = useState({
        password: "",
        passwordRepeat: "",
        token: ""
    });

    const [errors, setErrors] = useState({});
    const [modifSuccess, setModifSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
    const { token } = useParams();
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    // --- REGEX COMPLEXITÉ ---
    const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

    // -------------------------
    // RÉCUPÉRATION TOKEN URL
    // -------------------------
    useEffect(() => {
        if (token) {
            setFormData((prev) => ({ ...prev, token }));
        }
    }, [token]);

    // -------------------------
    // VALIDATION LIVE
    // -------------------------
    const validateField = (name, value) => {
        let fieldErrors = { ...errors };

        if (name === "password") {
            if (!passwordRegex.test(value)) {
                fieldErrors.password = (
                    <ul className="password-rules">
                        <li className={value.length >= 8 ? "ok" : "error"}>
                            {value.length >= 8 ? "✅" : "❌"} 8 caractères minimum
                        </li>
                        <li className={/[A-Z]/.test(value) ? "ok" : "error"}>
                            {/[A-Z]/.test(value) ? "✅" : "❌"} 1 majuscule
                        </li>
                        <li className={/[a-z]/.test(value) ? "ok" : "error"}>
                            {/[a-z]/.test(value) ? "ok" : "error"}
                            {/[a-z]/.test(value) ? " " : " "}1 minuscule
                        </li>
                        <li className={/\d/.test(value) ? "ok" : "error"}>
                            {/\d/.test(value) ? "ok" : "error"}
                            {/\d/.test(value) ? " " : " "}1 chiffre
                        </li>
                        <li className={
                            /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value)
                                ? "ok"
                                : "error"
                        }>
                            {/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value)
                                ? "ok"
                                : "error"}
                            {/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value)
                                ? " "
                                : " "}1 caractère spécial
                        </li>
                    </ul>
                );
            } else {
                delete fieldErrors.password;
            }
        }

        if (name === "passwordRepeat") {
            if (formData.password !== value) {
                fieldErrors.passwordRepeat = "Les mots de passe ne correspondent pas.";
            } else {
                delete fieldErrors.passwordRepeat;
            }
        }

        setErrors(fieldErrors);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({ ...prev, [name]: value }));
        validateField(name, value);
    };

    const canSubmit =
        formData.password &&
        formData.passwordRepeat &&
        Object.keys(errors).length === 0;

    // -------------------------
    // SUBMIT FORMULAIRE
    // -------------------------
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!canSubmit) return;

        const form = new FormData();
        form.append("token", formData.token);
        form.append("password", formData.password);
        form.append("repeatPassword", formData.passwordRepeat);

        try {
            const response = await fetch(`${apiUrl}/api/auth/reset-password`, {
                method: "POST",
                body: form,
            });

            const data = await response.json();

            if (!response.ok) {
                alert(data.error || "Erreur lors de la modification du mot de passe");
                return;
            }

            setModifSuccess(true);

        } catch (error) {
            alert("Erreur serveur, réessayez plus tard.");
        }
    };

    return (
        <div className="inscriptionModalOverlay">
            <div className="inscriptionModal">

                {!modifSuccess ? (
                    <>
                        <h2>Réinitialisation du mot de passe</h2>

                        <form onSubmit={handleSubmit}>

                            {/* Mot de passe */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Nouveau mot de passe</label>

                                <div className="password-wrapper">
                                    <input
                                        name="password"
                                        type={showPassword ? "text" : "password"}
                                        value={formData.password}
                                        placeholder="Votre mot de passe"
                                        onChange={handleChange}
                                        required
                                    />
                                    <span
                                        className="togglePassword"
                                        onClick={() => setShowPassword((v) => !v)}
                                    >
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                    </span>
                                </div>

                                {errors.password && <>{errors.password}</>}
                            </div>

                            {/* Confirmation */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Répétez le mot de passe</label>

                                <div className="password-wrapper">
                                    <input
                                        name="passwordRepeat"
                                        type={showPasswordRepeat ? "text" : "password"}
                                        value={formData.passwordRepeat}
                                        placeholder="Répétez votre mot de passe"
                                        onChange={handleChange}
                                        required
                                    />
                                    <span
                                        className="togglePassword"
                                        onClick={() => setShowPasswordRepeat((v) => !v)}
                                    >
                                        <FontAwesomeIcon icon={showPasswordRepeat ? faEyeSlash : faEye} />
                                    </span>
                                </div>

                                {errors.passwordRepeat && (
                                    <p className="error-text">{errors.passwordRepeat}</p>
                                )}
                            </div>

                            <button className="btn-primary" type="submit" disabled={!canSubmit}>
                                Modifier mon mot de passe
                            </button>
                        </form>
                    </>
                ) : (
                    <>
                        <h2>Mot de passe modifié</h2>
                        <p>Vous pouvez maintenant vous reconnecter avec votre nouveau mot de passe.</p>
                        <button className="btn-primary" onClick={()=>navigate("/")}>OK</button>
                    </>
                )}
            </div>
        </div>
    );
}
